module.exports = __webpack_public_path__ + "img/share-shop.c73414d.svg";